<div class="custom-dropdown-wrapper">
    <div class="custom-overlay" *ngIf="isDropdownOpen" (click)="toggleOpen()"></div>
    <div class="custom-dropdown-toggle" (click)="toggleOpen()">
        <ng-content select="[dropdown-toggle]"/>
    </div>
    <div *ngIf="isDropdownOpen" class="custom-dropdown-list">
        <div class="custom-dropdown-items-wrapper">
            <ng-content select="[dropdown-list]"/>
        </div>
    </div>
</div>